// Data Ops — one home for the directory data-cleaning tools. Tiles deep-link to
// each full tool (kept standalone so heavy tools only load when opened).
import React from 'react';
import { ConsoleShell, Panel, SectionLabel, useConsoleTheme, useIsMobile } from '../components/Console';

const F = 'system-ui,-apple-system,"Helvetica Neue",Arial,sans-serif';

const TOOLS = [
  { id:'dataquality',      label:'Data Quality',      desc:'Field coverage, completeness scores, pipeline health.', accent:'#314F5C' },
  { id:'duplicates',       label:'Duplicates',        desc:'Detect and merge duplicate venue records.',            accent:'#e8736b' },
  { id:'bulkeditor',       label:'Bulk Editor',       desc:'Search, select, and bulk-update many records at once.', accent:'#6F8FA7' },
  { id:'tagnormalizer',    label:'Tag Normalizer',    desc:'Standardise messy type/tag values across the catalogue.', accent:'#819D84' },
  { id:'geocoding',        label:'Geocoding',         desc:'Fill missing GPS via Nominatim; fix bad coordinates.',  accent:'#9F7E4F' },
  { id:'locationquality',  label:'Location Quality',  desc:'Per-record quality tiers and the display floor.',       accent:'#5dcaa5' },
  { id:'datacompleteness', label:'Data Completeness', desc:'Which fields are filled vs missing, by country/type.',  accent:'#85b7eb' },
  { id:'verifyqueue',      label:'Verify Queue',      desc:'Records awaiting human verification.',                  accent:'#f0b357' },
];

function Tile({ tool, onNav }) {
  const { t } = useConsoleTheme();
  const [h, setH] = React.useState(false);
  return (
    <div onClick={() => onNav && onNav(tool.id)} onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)}
      style={{ background:t.panel, border:`1px solid ${t.bd}`, borderRadius:11, padding:'16px 18px', cursor:'pointer',
        transform: h ? 'translateY(-2px)' : 'none', boxShadow: h ? '0 8px 20px rgba(0,0,0,0.16)' : 'none',
        transition:'transform .15s, box-shadow .15s', position:'relative', overflow:'hidden' }}>
      <div style={{ position:'absolute', top:0, left:0, right:0, height:3, background:tool.accent }} />
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:8 }}>
        <span style={{ fontSize:'1.1rem', fontWeight:600, color:t.tx }}>{tool.label}</span>
        <span style={{ fontSize:'1rem', color: h ? tool.accent : t.mut, transition:'color .15s' }}>→</span>
      </div>
      <div style={{ fontSize:'0.95rem', color:t.mut, lineHeight:1.5 }}>{tool.desc}</div>
    </div>
  );
}

function Body({ onNav }) {
  const { t } = useConsoleTheme();
  const mobile = useIsMobile();
  return (
    <div>
      <SectionLabel right={`${TOOLS.length} tools`}>Directory data operations</SectionLabel>
      <Panel style={{ background:'transparent', border:'none', padding:0 }}>
        <div style={{ display:'grid', gridTemplateColumns: mobile ? '1fr' : 'repeat(auto-fit, minmax(280px, 1fr))', gap:12 }}>
          {TOOLS.map(tool => <Tile key={tool.id} tool={tool} onNav={onNav} />)}
        </div>
      </Panel>
      <div style={{ marginTop:16, fontSize:'0.92rem', color:t.mut, fontFamily:F }}>
        Each tool opens full-screen and loads its own data — kept separate so the heavy ones (Duplicates, Bulk Editor) only run when you open them.
      </div>
    </div>
  );
}

export default function DataOps(props) {
  return <ConsoleShell title="Data Ops"><Body onNav={props && props.onNav} /></ConsoleShell>;
}
